class OnlyAlpha {
    validate(data) {
        if (Number.isInteger(data)) {
            return { isValid: false };
        }
        if (data === "") {
            return { isValid: true };
        }
        return {
            isValid: /^[a-zA-Z\-_.äöüß ]+$/i.test(data)
        };
    }
}
export default OnlyAlpha;
